import { useDraftPersistence } from "@/hooks/useDraftPersistence";
import { useCallback } from "react";

import { OnboardingDraft } from "@/types/onboarding"; // we will create but we can inline type

export const useOnboardingPersistence = (
  snapshot: () => OnboardingDraft,
  hydrate: (draft: OnboardingDraft) => void,
) => {
  return useDraftPersistence<OnboardingDraft>("ONBOARDING", snapshot, hydrate);
}; 